

<nav [ngClass]="{ 'bg-white nav--expanded': sidebarExpanded }">
    <button
      (click)="toggleSidebarExpanded()"
      *ngIf="!sidebarExpanded"
      class="sidebar-menu-toggle ms-2 mt-2"
    >
      <app-sidebar-new-comp name="menuIcon" />
    </button>
  
    <button
      *ngIf="sidebarExpanded"
      class="close-button"
      (click)="toggleSidebarExpanded()"
    >
      <app-sidebar-new-comp name="tabmenuIcon" />
    </button>
    <a
      *ngIf="sidebarExpanded"
      href="/"
      class="site-logo"
    >
      <img
        src="../../../../assets/images/side bar icons/grammarin-logo.svg"
        alt=""
        width="180" height="46"
    />
  
  
  
  </a>
  
  
    <ul *ngIf="isUserLoggedin">
      <li
        *ngFor="let link of navbarLinksLogIn"
        class="sidebar-nav-item "
        style="cursor: pointer"
        [ngClass]="{ hidden: !sidebarExpanded }"
      >
        <a href="javascript:void(0);" (click)="link.function()" >
          <app-sidebar-new-comp [name]="link.icon" ></app-sidebar-new-comp>
          <span [ngClass]="{ hidden: !sidebarExpanded }">{{ link.text }}</span>
        </a>
  
 
  
        <!-- Check submenu existence before looping -->
        <ul *ngIf="link.submenu?.length" class="sidebar-submenu">
          <li *ngFor="let sub of link.submenu" style="cursor: pointer">
            <a href="javascript:void(0);" (click)="sub.function()">{{
              sub.text
            }}</a>
          </li>
        </ul>
      </li>
    </ul>
  
    <ul *ngIf="!isUserLoggedin">
      <li
        *ngFor="let link of navbarLinksNotLogIn"
        class="sidebar-nav-item "
        style="cursor: pointer"
        [ngClass]="{ hidden: !sidebarExpanded }"
      >
        <a href="javascript:void(0);" (click)="link.function()">
          <app-sidebar-new-comp [name]="link.icon"></app-sidebar-new-comp>
          <span [ngClass]="{ hidden: !sidebarExpanded }">{{ link.text }}</span>
        </a>
  
  
        <!-- Check submenu existence before looping -->
        <ul *ngIf="link.submenu?.length" class="sidebar-submenu">
          <li *ngFor="let sub of link.submenu" style="cursor: pointer">
            <a href="javascript:void(0);" (click)="sub.function()">{{
              sub.text
            }}</a>
          </li>
        </ul>
      </li>
    </ul>
  
    <div></div>
  </nav>
  
